import { useEffect, useMemo, useState } from 'react';
import { Navigate } from 'react-router-dom';
import Login from "../views/login/Login";
import ForgotPassword from "../views/forgot-password/ForgotPassword";
import TokenVerification from "../views/token-verification/TokenVerification";
import { AppDispatch, useSelector } from "../redux/store";
import PageWrapper from "../layouts/full/dataShield/PageWrapper";
import Logout from "../views/logout/Logout";
import { logout } from "../redux/actions/authActions";
import Home from "../views/home/Home";
import Analysis from "../views/analysis/Analysis";
import Reports from '../views/reports/Reports';
import AddFacilityPage from '../views/reports/AddFacilityPage';
import ReportPages from '../views/reports/[id]/reportpages';
import ChecklistPage from '../views/reports/[id]/ChecklistPage';
import BulguEklePage from '../views/reports/[id]/BulguEklePage';
import AuditSummaryPage from '../views/reports/[id]/AuditSummaryPage';
import Admin from '../views/admin/Admin';
import ReportView from '../views/report-view/ReportView';
import CacheService from '../services/CacheService';
import LogoSpinner from '../components/LogoSpinner/LogoSpinner';
import RequireAdmin from './RequireAdmin';
import SSOCallback from '../views/login/SSOCallback';

/* ****Pages***** */
const Routes = () => {
	const accessToken = useSelector((state) => state.auth.accessToken)
	const [isCheckingAuth, setIsCheckingAuth] = useState(true);

	// Auth check tamamlandıktan sonra loading'i kapat
	useEffect(() => {
		const timer = setTimeout(() => {
			setIsCheckingAuth(false);
		}, 200);

		return () => clearTimeout(timer);
	}, []);

	// Auth kontrolü devam ediyorsa loading göster
	if (isCheckingAuth) {
		return [{
			path: '*',
			element: <LogoSpinner size={64} minHeight="100vh" />
		}];
	}

	// Token yoksa login sayfalarını göster
	if (!accessToken) {
		return [
			{
				path: '/',
				element: <Navigate to="/login" replace />,
			},
			{
				path: '/login',
				element: <Login />,
			},
			{
				path: '/verification',
				element: <TokenVerification />,
			},
			{
				path: '/forgot-password',
				element: <ForgotPassword />,
			},
			{
				path: '/sso-callback',
				element: <SSOCallback />,
			},
			{
				path: '*',
				element: <Navigate to="/login" replace />,
			}
		];
	}

	// Token varsa authenticated sayfaları göster
	return [
		{
			path: '/',
			element: <PageWrapper />,
			children: [
				{
					index: true,
					element: <Home />
				},
				{
					path: 'home',
					element: <Home />
				},
				{
					path: 'analysis',
					element: <Analysis />,
				},
				{
					path: 'reports',
					element: <Reports />,
				},
				{
					path: 'reports/yeni-tesis',
					element: <AddFacilityPage />,
				},
			{
				path: 'reports/:id',
				element: <ReportPages />
			},
			{
				path: 'reports/:id/checklist',
				element: <ChecklistPage />
			},
			{
				path: 'reports/:id/checklist/summary',
				element: <AuditSummaryPage />
			},
			{
				path: 'reports/:id/checklist/bulgu',
				element: <BulguEklePage />
			},
			{
				path: 'reports/:id/checklist/bulgu/:questionId',
				element: <BulguEklePage />
			},
				{
					path: 'admin',
					element: (
						<RequireAdmin>
							<Admin />
						</RequireAdmin>
					),
				},
				{
					path: 'notifications',
					element: <div>Notifications Page</div>,
				},
				{
					path: 'logout',
					element: <Logout />,
				},
			],
		},
		{
			path: '/login',
			element: <Navigate to="/" replace />,
		},
		{
			path: '/report-view/:id',
			element: <ReportView />,
		},
		{
			path: '/sso-callback',
			element: <SSOCallback />,
		},
		{
			path: '*',
			element: <Navigate to="/" replace />,
		}
	];
}

export default Routes;
